import { useState, useEffect } from 'react';
import FaIcon from './FaIcon';
import { networkService } from '@/services/network.service';

export default function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!networkService.isOnline());
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const removeListener = networkService.addListener((connected) => {
      setIsOffline(!connected);
      setDismissed(false);
    });

    return () => {
      removeListener();
    };
  }, []);

  if (!isOffline || dismissed) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 dark:bg-amber-600 text-white px-4 py-2 flex items-center justify-between gap-2 text-sm font-medium shadow-md"
      style={{ paddingTop: 'max(0.5rem, env(safe-area-inset-top))' }}
      role="alert"
    >
      <div className="flex items-center gap-2">
        <FaIcon icon="wifi-slash" className="h-4 w-4 flex-shrink-0" />
        <span>You're offline. Changes will sync when reconnected.</span>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="min-h-[44px] min-w-[44px] flex items-center justify-center touch-manipulation"
        aria-label="Dismiss offline notification"
      >
        <FaIcon icon="xmark" className="h-4 w-4" />
      </button>
    </div>
  );
}
